import { render, staticRenderFns } from "./SmsAndroidSetting.vue?vue&type=template&id=3b4a4f18&scoped=true"
import script from "./SmsAndroidSetting.vue?vue&type=script&lang=js"
export * from "./SmsAndroidSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a4f18",
  null
  
)

export default component.exports